import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { ticketsApi } from "../api/ticketsApi";
import type { AssistantProfile } from "../types/tickets";

export function useAssistantProfile() {
  return useQuery({ queryKey: ["assistant", "profile"], queryFn: ticketsApi.getProfile });
}

export function useUpdateAssistantProfile() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: Partial<AssistantProfile>) => ticketsApi.updateProfile(body),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["assistant", "profile"] }),
  });
}
